import { fromCollectionRef } from '../observable/fromRef';
import { map, scan } from 'rxjs/operators';
export function docChanges(query, scheduler) {
    return fromCollectionRef(query, scheduler)
        .pipe(map(action => action.payload.docChanges()
        .map(change => ({ type: change.type, payload: change }))));
}
export function sortedChanges(query, events, scheduler) {
    return fromCollectionRef(query, scheduler)
        .pipe(map(changes => changes.payload.docChanges()), scan((current, changes) => combineChanges(current, changes, events), []), map(changes => changes.map(c => ({ type: c.type, payload: c }))));
}
export function combineChanges(current, changes, events) {
    changes.forEach(change => {
        if (events.indexOf(change.type) > -1) {
            current = combineChange(current, change);
        }
    });
    return current;
}
export function combineChange(combined, change) {
    switch (change.type) {
        case 'added':
            if (combined[change.newIndex] && combined[change.newIndex].doc.ref.isEqual(change.doc.ref)) {
            }
            else {
                combined.splice(change.newIndex, 0, change);
            }
            break;
        case 'modified':
            if (combined[change.oldIndex] == null || combined[change.oldIndex].doc.ref.isEqual(change.doc.ref)) {
                if (change.oldIndex !== change.newIndex) {
                    combined.splice(change.oldIndex, 1);
                    combined.splice(change.newIndex, 0, change);
                }
                else {
                    combined.splice(change.newIndex, 1, change);
                }
            }
            break;
        case 'removed':
            if (combined[change.oldIndex] && combined[change.oldIndex].doc.ref.isEqual(change.doc.ref)) {
                combined.splice(change.oldIndex, 1);
            }
            break;
    }
    return combined;
}
//# sourceMappingURL=changes.js.map